/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout.index'
import { Route as JoinLayoutRouteImport } from './routes/join/_layout'
import { Route as CreateLayoutRouteImport } from './routes/create/_layout'
import { Route as LayoutTrainingStyleRouteImport } from './routes/_layout.trainingStyle'
import { Route as LayoutTrainingPlansRouteImport } from './routes/_layout.trainingPlans'
import { Route as LayoutTrainingPlanDetailsRouteImport } from './routes/_layout.trainingPlanDetails'
import { Route as LayoutTrainerGenderRouteImport } from './routes/_layout.trainerGender'
import { Route as LayoutSignUpRouteImport } from './routes/_layout.signUp'
import { Route as LayoutProfileRouteImport } from './routes/_layout.profile'
import { Route as LayoutNumDaysRouteImport } from './routes/_layout.numDays'
import { Route as LayoutFitnessGoalRouteImport } from './routes/_layout.fitnessGoal'
import { Route as LayoutExperienceLevelRouteImport } from './routes/_layout.experienceLevel'
import { Route as LayoutEquipmentRouteImport } from './routes/_layout.equipment'
import { Route as LayoutDurationRouteImport } from './routes/_layout.duration'
import { Route as LayoutDaysOfWeekRouteImport } from './routes/_layout.daysOfWeek'
import { Route as JoinLayoutIndexRouteImport } from './routes/join/_layout.index'
import { Route as CreateLayoutIndexRouteImport } from './routes/create/_layout.index'
import { Route as JoinLayoutIsNewRouteImport } from './routes/join/_layout.isNew'
import { Route as JoinLayoutInviteCodeRouteImport } from './routes/join/_layout.inviteCode'
import { Route as CreateLayoutQrCodeRouteImport } from './routes/create/_layout.qrCode'
import { Route as CreateLayoutNameRouteImport } from './routes/create/_layout.name'
import { Route as CreateLayoutInviteRouteImport } from './routes/create/_layout.invite'

const JoinRouteImport = createFileRoute('/join')()
const CreateRouteImport = createFileRoute('/create')()

const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateRoute = CreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutRoute = LayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const LayoutIndexRoute = LayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)
const JoinLayoutRoute = JoinLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => JoinRoute,
} as any)
const CreateLayoutRoute = CreateLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => CreateRoute,
} as any)
const LayoutTrainingStyleRoute = LayoutTrainingStyleRouteImport.update({
  id: '/trainingStyle',
  path: '/trainingStyle',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTrainingPlansRoute = LayoutTrainingPlansRouteImport.update({
  id: '/trainingPlans',
  path: '/trainingPlans',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutTrainingPlanDetailsRoute =
  LayoutTrainingPlanDetailsRouteImport.update({
    id: '/trainingPlanDetails',
    path: '/trainingPlanDetails',
    getParentRoute: () => LayoutRoute,
  } as any)
const LayoutTrainerGenderRoute = LayoutTrainerGenderRouteImport.update({
  id: '/trainerGender',
  path: '/trainerGender',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutSignUpRoute = LayoutSignUpRouteImport.update({
  id: '/signUp',
  path: '/signUp',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutProfileRoute = LayoutProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutNumDaysRoute = LayoutNumDaysRouteImport.update({
  id: '/numDays',
  path: '/numDays',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutFitnessGoalRoute = LayoutFitnessGoalRouteImport.update({
  id: '/fitnessGoal',
  path: '/fitnessGoal',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutExperienceLevelRoute = LayoutExperienceLevelRouteImport.update({
  id: '/experienceLevel',
  path: '/experienceLevel',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutEquipmentRoute = LayoutEquipmentRouteImport.update({
  id: '/equipment',
  path: '/equipment',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDurationRoute = LayoutDurationRouteImport.update({
  id: '/duration',
  path: '/duration',
  getParentRoute: () => LayoutRoute,
} as any)
const LayoutDaysOfWeekRoute = LayoutDaysOfWeekRouteImport.update({
  id: '/daysOfWeek',
  path: '/daysOfWeek',
  getParentRoute: () => LayoutRoute,
} as any)
const JoinLayoutIndexRoute = JoinLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JoinLayoutRoute,
} as any)
const CreateLayoutIndexRoute = CreateLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CreateLayoutRoute,
} as any)
const JoinLayoutIsNewRoute = JoinLayoutIsNewRouteImport.update({
  id: '/isNew',
  path: '/isNew',
  getParentRoute: () => JoinLayoutRoute,
} as any)
const JoinLayoutInviteCodeRoute = JoinLayoutInviteCodeRouteImport.update({
  id: '/inviteCode',
  path: '/inviteCode',
  getParentRoute: () => JoinLayoutRoute,
} as any)
const CreateLayoutQrCodeRoute = CreateLayoutQrCodeRouteImport.update({
  id: '/qrCode',
  path: '/qrCode',
  getParentRoute: () => CreateLayoutRoute,
} as any)
const CreateLayoutNameRoute = CreateLayoutNameRouteImport.update({
  id: '/name',
  path: '/name',
  getParentRoute: () => CreateLayoutRoute,
} as any)
const CreateLayoutInviteRoute = CreateLayoutInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => CreateLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/daysOfWeek': typeof LayoutDaysOfWeekRoute
  '/duration': typeof LayoutDurationRoute
  '/equipment': typeof LayoutEquipmentRoute
  '/experienceLevel': typeof LayoutExperienceLevelRoute
  '/fitnessGoal': typeof LayoutFitnessGoalRoute
  '/numDays': typeof LayoutNumDaysRoute
  '/profile': typeof LayoutProfileRoute
  '/signUp': typeof LayoutSignUpRoute
  '/trainerGender': typeof LayoutTrainerGenderRoute
  '/trainingPlanDetails': typeof LayoutTrainingPlanDetailsRoute
  '/trainingPlans': typeof LayoutTrainingPlansRoute
  '/trainingStyle': typeof LayoutTrainingStyleRoute
  '/create': typeof CreateLayoutRouteWithChildren
  '/join': typeof JoinLayoutRouteWithChildren
  '/': typeof LayoutIndexRoute
  '/create/invite': typeof CreateLayoutInviteRoute
  '/create/name': typeof CreateLayoutNameRoute
  '/create/qrCode': typeof CreateLayoutQrCodeRoute
  '/join/inviteCode': typeof JoinLayoutInviteCodeRoute
  '/join/isNew': typeof JoinLayoutIsNewRoute
  '/create/': typeof CreateLayoutIndexRoute
  '/join/': typeof JoinLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/daysOfWeek': typeof LayoutDaysOfWeekRoute
  '/duration': typeof LayoutDurationRoute
  '/equipment': typeof LayoutEquipmentRoute
  '/experienceLevel': typeof LayoutExperienceLevelRoute
  '/fitnessGoal': typeof LayoutFitnessGoalRoute
  '/numDays': typeof LayoutNumDaysRoute
  '/profile': typeof LayoutProfileRoute
  '/signUp': typeof LayoutSignUpRoute
  '/trainerGender': typeof LayoutTrainerGenderRoute
  '/trainingPlanDetails': typeof LayoutTrainingPlanDetailsRoute
  '/trainingPlans': typeof LayoutTrainingPlansRoute
  '/trainingStyle': typeof LayoutTrainingStyleRoute
  '/create': typeof CreateLayoutIndexRoute
  '/join': typeof JoinLayoutIndexRoute
  '/': typeof LayoutIndexRoute
  '/create/invite': typeof CreateLayoutInviteRoute
  '/create/name': typeof CreateLayoutNameRoute
  '/create/qrCode': typeof CreateLayoutQrCodeRoute
  '/join/inviteCode': typeof JoinLayoutInviteCodeRoute
  '/join/isNew': typeof JoinLayoutIsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_layout': typeof LayoutRouteWithChildren
  '/_layout/daysOfWeek': typeof LayoutDaysOfWeekRoute
  '/_layout/duration': typeof LayoutDurationRoute
  '/_layout/equipment': typeof LayoutEquipmentRoute
  '/_layout/experienceLevel': typeof LayoutExperienceLevelRoute
  '/_layout/fitnessGoal': typeof LayoutFitnessGoalRoute
  '/_layout/numDays': typeof LayoutNumDaysRoute
  '/_layout/profile': typeof LayoutProfileRoute
  '/_layout/signUp': typeof LayoutSignUpRoute
  '/_layout/trainerGender': typeof LayoutTrainerGenderRoute
  '/_layout/trainingPlanDetails': typeof LayoutTrainingPlanDetailsRoute
  '/_layout/trainingPlans': typeof LayoutTrainingPlansRoute
  '/_layout/trainingStyle': typeof LayoutTrainingStyleRoute
  '/create': typeof CreateRouteWithChildren
  '/create/_layout': typeof CreateLayoutRouteWithChildren
  '/join': typeof JoinRouteWithChildren
  '/join/_layout': typeof JoinLayoutRouteWithChildren
  '/_layout/': typeof LayoutIndexRoute
  '/create/_layout/invite': typeof CreateLayoutInviteRoute
  '/create/_layout/name': typeof CreateLayoutNameRoute
  '/create/_layout/qrCode': typeof CreateLayoutQrCodeRoute
  '/join/_layout/inviteCode': typeof JoinLayoutInviteCodeRoute
  '/join/_layout/isNew': typeof JoinLayoutIsNewRoute
  '/create/_layout/': typeof CreateLayoutIndexRoute
  '/join/_layout/': typeof JoinLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/daysOfWeek'
    | '/duration'
    | '/equipment'
    | '/experienceLevel'
    | '/fitnessGoal'
    | '/numDays'
    | '/profile'
    | '/signUp'
    | '/trainerGender'
    | '/trainingPlanDetails'
    | '/trainingPlans'
    | '/trainingStyle'
    | '/create'
    | '/join'
    | '/'
    | '/create/invite'
    | '/create/name'
    | '/create/qrCode'
    | '/join/inviteCode'
    | '/join/isNew'
    | '/create/'
    | '/join/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/daysOfWeek'
    | '/duration'
    | '/equipment'
    | '/experienceLevel'
    | '/fitnessGoal'
    | '/numDays'
    | '/profile'
    | '/signUp'
    | '/trainerGender'
    | '/trainingPlanDetails'
    | '/trainingPlans'
    | '/trainingStyle'
    | '/create'
    | '/join'
    | '/'
    | '/create/invite'
    | '/create/name'
    | '/create/qrCode'
    | '/join/inviteCode'
    | '/join/isNew'
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/daysOfWeek'
    | '/_layout/duration'
    | '/_layout/equipment'
    | '/_layout/experienceLevel'
    | '/_layout/fitnessGoal'
    | '/_layout/numDays'
    | '/_layout/profile'
    | '/_layout/signUp'
    | '/_layout/trainerGender'
    | '/_layout/trainingPlanDetails'
    | '/_layout/trainingPlans'
    | '/_layout/trainingStyle'
    | '/create'
    | '/create/_layout'
    | '/join'
    | '/join/_layout'
    | '/_layout/'
    | '/create/_layout/invite'
    | '/create/_layout/name'
    | '/create/_layout/qrCode'
    | '/join/_layout/inviteCode'
    | '/join/_layout/isNew'
    | '/create/_layout/'
    | '/join/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  CreateRoute: typeof CreateRouteWithChildren
  JoinRoute: typeof JoinRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create': {
      id: '/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/join/_layout': {
      id: '/join/_layout'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinLayoutRouteImport
      parentRoute: typeof JoinRoute
    }
    '/create/_layout': {
      id: '/create/_layout'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof CreateLayoutRouteImport
      parentRoute: typeof CreateRoute
    }
    '/_layout/trainingStyle': {
      id: '/_layout/trainingStyle'
      path: '/trainingStyle'
      fullPath: '/trainingStyle'
      preLoaderRoute: typeof LayoutTrainingStyleRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trainingPlans': {
      id: '/_layout/trainingPlans'
      path: '/trainingPlans'
      fullPath: '/trainingPlans'
      preLoaderRoute: typeof LayoutTrainingPlansRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trainingPlanDetails': {
      id: '/_layout/trainingPlanDetails'
      path: '/trainingPlanDetails'
      fullPath: '/trainingPlanDetails'
      preLoaderRoute: typeof LayoutTrainingPlanDetailsRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/trainerGender': {
      id: '/_layout/trainerGender'
      path: '/trainerGender'
      fullPath: '/trainerGender'
      preLoaderRoute: typeof LayoutTrainerGenderRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/signUp': {
      id: '/_layout/signUp'
      path: '/signUp'
      fullPath: '/signUp'
      preLoaderRoute: typeof LayoutSignUpRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/profile': {
      id: '/_layout/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof LayoutProfileRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/numDays': {
      id: '/_layout/numDays'
      path: '/numDays'
      fullPath: '/numDays'
      preLoaderRoute: typeof LayoutNumDaysRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/fitnessGoal': {
      id: '/_layout/fitnessGoal'
      path: '/fitnessGoal'
      fullPath: '/fitnessGoal'
      preLoaderRoute: typeof LayoutFitnessGoalRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/experienceLevel': {
      id: '/_layout/experienceLevel'
      path: '/experienceLevel'
      fullPath: '/experienceLevel'
      preLoaderRoute: typeof LayoutExperienceLevelRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/equipment': {
      id: '/_layout/equipment'
      path: '/equipment'
      fullPath: '/equipment'
      preLoaderRoute: typeof LayoutEquipmentRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/duration': {
      id: '/_layout/duration'
      path: '/duration'
      fullPath: '/duration'
      preLoaderRoute: typeof LayoutDurationRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/_layout/daysOfWeek': {
      id: '/_layout/daysOfWeek'
      path: '/daysOfWeek'
      fullPath: '/daysOfWeek'
      preLoaderRoute: typeof LayoutDaysOfWeekRouteImport
      parentRoute: typeof LayoutRoute
    }
    '/join/_layout/': {
      id: '/join/_layout/'
      path: '/'
      fullPath: '/join/'
      preLoaderRoute: typeof JoinLayoutIndexRouteImport
      parentRoute: typeof JoinLayoutRoute
    }
    '/create/_layout/': {
      id: '/create/_layout/'
      path: '/'
      fullPath: '/create/'
      preLoaderRoute: typeof CreateLayoutIndexRouteImport
      parentRoute: typeof CreateLayoutRoute
    }
    '/join/_layout/isNew': {
      id: '/join/_layout/isNew'
      path: '/isNew'
      fullPath: '/join/isNew'
      preLoaderRoute: typeof JoinLayoutIsNewRouteImport
      parentRoute: typeof JoinLayoutRoute
    }
    '/join/_layout/inviteCode': {
      id: '/join/_layout/inviteCode'
      path: '/inviteCode'
      fullPath: '/join/inviteCode'
      preLoaderRoute: typeof JoinLayoutInviteCodeRouteImport
      parentRoute: typeof JoinLayoutRoute
    }
    '/create/_layout/qrCode': {
      id: '/create/_layout/qrCode'
      path: '/qrCode'
      fullPath: '/create/qrCode'
      preLoaderRoute: typeof CreateLayoutQrCodeRouteImport
      parentRoute: typeof CreateLayoutRoute
    }
    '/create/_layout/name': {
      id: '/create/_layout/name'
      path: '/name'
      fullPath: '/create/name'
      preLoaderRoute: typeof CreateLayoutNameRouteImport
      parentRoute: typeof CreateLayoutRoute
    }
    '/create/_layout/invite': {
      id: '/create/_layout/invite'
      path: '/invite'
      fullPath: '/create/invite'
      preLoaderRoute: typeof CreateLayoutInviteRouteImport
      parentRoute: typeof CreateLayoutRoute
    }
  }
}

interface LayoutRouteChildren {
  LayoutDaysOfWeekRoute: typeof LayoutDaysOfWeekRoute
  LayoutDurationRoute: typeof LayoutDurationRoute
  LayoutEquipmentRoute: typeof LayoutEquipmentRoute
  LayoutExperienceLevelRoute: typeof LayoutExperienceLevelRoute
  LayoutFitnessGoalRoute: typeof LayoutFitnessGoalRoute
  LayoutNumDaysRoute: typeof LayoutNumDaysRoute
  LayoutProfileRoute: typeof LayoutProfileRoute
  LayoutSignUpRoute: typeof LayoutSignUpRoute
  LayoutTrainerGenderRoute: typeof LayoutTrainerGenderRoute
  LayoutTrainingPlanDetailsRoute: typeof LayoutTrainingPlanDetailsRoute
  LayoutTrainingPlansRoute: typeof LayoutTrainingPlansRoute
  LayoutTrainingStyleRoute: typeof LayoutTrainingStyleRoute
  LayoutIndexRoute: typeof LayoutIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutDaysOfWeekRoute: LayoutDaysOfWeekRoute,
  LayoutDurationRoute: LayoutDurationRoute,
  LayoutEquipmentRoute: LayoutEquipmentRoute,
  LayoutExperienceLevelRoute: LayoutExperienceLevelRoute,
  LayoutFitnessGoalRoute: LayoutFitnessGoalRoute,
  LayoutNumDaysRoute: LayoutNumDaysRoute,
  LayoutProfileRoute: LayoutProfileRoute,
  LayoutSignUpRoute: LayoutSignUpRoute,
  LayoutTrainerGenderRoute: LayoutTrainerGenderRoute,
  LayoutTrainingPlanDetailsRoute: LayoutTrainingPlanDetailsRoute,
  LayoutTrainingPlansRoute: LayoutTrainingPlansRoute,
  LayoutTrainingStyleRoute: LayoutTrainingStyleRoute,
  LayoutIndexRoute: LayoutIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

interface CreateLayoutRouteChildren {
  CreateLayoutInviteRoute: typeof CreateLayoutInviteRoute
  CreateLayoutNameRoute: typeof CreateLayoutNameRoute
  CreateLayoutQrCodeRoute: typeof CreateLayoutQrCodeRoute
  CreateLayoutIndexRoute: typeof CreateLayoutIndexRoute
}

const CreateLayoutRouteChildren: CreateLayoutRouteChildren = {
  CreateLayoutInviteRoute: CreateLayoutInviteRoute,
  CreateLayoutNameRoute: CreateLayoutNameRoute,
  CreateLayoutQrCodeRoute: CreateLayoutQrCodeRoute,
  CreateLayoutIndexRoute: CreateLayoutIndexRoute,
}

const CreateLayoutRouteWithChildren = CreateLayoutRoute._addFileChildren(
  CreateLayoutRouteChildren,
)

interface CreateRouteChildren {
  CreateLayoutRoute: typeof CreateLayoutRouteWithChildren
}

const CreateRouteChildren: CreateRouteChildren = {
  CreateLayoutRoute: CreateLayoutRouteWithChildren,
}

const CreateRouteWithChildren =
  CreateRoute._addFileChildren(CreateRouteChildren)

interface JoinLayoutRouteChildren {
  JoinLayoutInviteCodeRoute: typeof JoinLayoutInviteCodeRoute
  JoinLayoutIsNewRoute: typeof JoinLayoutIsNewRoute
  JoinLayoutIndexRoute: typeof JoinLayoutIndexRoute
}

const JoinLayoutRouteChildren: JoinLayoutRouteChildren = {
  JoinLayoutInviteCodeRoute: JoinLayoutInviteCodeRoute,
  JoinLayoutIsNewRoute: JoinLayoutIsNewRoute,
  JoinLayoutIndexRoute: JoinLayoutIndexRoute,
}

const JoinLayoutRouteWithChildren = JoinLayoutRoute._addFileChildren(
  JoinLayoutRouteChildren,
)

interface JoinRouteChildren {
  JoinLayoutRoute: typeof JoinLayoutRouteWithChildren
}

const JoinRouteChildren: JoinRouteChildren = {
  JoinLayoutRoute: JoinLayoutRouteWithChildren,
}

const JoinRouteWithChildren = JoinRoute._addFileChildren(JoinRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  CreateRoute: CreateRouteWithChildren,
  JoinRoute: JoinRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
